import React from "react";

import { UPLOAD_INFO_ITEMS } from "../constants/uploadsContent";
import styles from "../containers/Uploads/UploadsContainer.module.scss";

const UploadInfoGrid = () => (
  <div className={styles.infoGrid}>
    {UPLOAD_INFO_ITEMS.map((item) => (
      <div key={item.id} className={styles.infoItem}>
        <span className={styles.infoLabel}>{item.label}</span>
        <span className={styles.infoValue}>{item.value}</span>
      </div>
    ))}
  </div>
);

export default UploadInfoGrid;
